var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resource-reference"},[(_vm.resource)?_c('resource',{attrs:{"content":_vm.resource}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }